<template>
    <div class="breadcrumb-box">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item ><span style="cursor: pointer;" @click='getchange()'>{{$t('menu.home')}}</span></el-breadcrumb-item>
            <template v-for="(item, index) in curBreadList">
                <el-breadcrumb-item v-if="item.path" :to="item.path" :key="index"><span>{{getLangMenu(item.menu)}}</span></el-breadcrumb-item>
                <el-breadcrumb-item v-else :key="index"><span>{{getLangMenu(item.menu)}}</span></el-breadcrumb-item>
            </template>
        </el-breadcrumb>
    </div>
</template>

<script>
import { getLangMenu } from '@/utils/getLangDict'
import Storage from '@/utils/storage'
export default {
    name: "breadcrumb",
    data() {
        return {
            curBreadList: [],
        };
    },
    created() {
        
    },
    mounted() {
        this.getBreadcrumb(this.$route.meta)
    },
    watch: {
        $route(to, from) {
            this.getBreadcrumb(to.meta);
        },
    },
    methods: {
        getLangMenu,
        getBreadcrumb(meta) {
            let breadcrumb = meta.breadcrumb || []
            this.curBreadList = breadcrumb;
        },
		getchange(){
			let id=Storage.get('ProjectSystemInfo').projectsystemInfo.sys_type_id
			if(id == 1) {
				this.$router.push({ path: "/machineHome" });
			}else if(id == 3){
			    // 新机房子系统
			    this.$router.push({ path: "/machinemana/0" });
			}else{
			    // 群控系统+计费系统
			    this.$router.push({ path: "/home" });
			}
		}
    }
};
</script>

<style lang="less">

.breadcrumb-box {
    height: 60px;
    line-height: 60px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 20px;
}
.el-breadcrumb {
    line-height: 60px;
    color: #fff;
    font-size: 14px;
}
.el-breadcrumb__inner{
    color: #fff!important;
}
.reload-btn{
   
}
</style>
